import React from 'react';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const EmailVerificationView = ({ 
  user, 
  onVerifyEmail, 
  onResendVerification,
  checking,
  resending,
  resendStatus 
}) => {
  return (
    <div className={styles.verificationOverlay}>
      <h1>Verify Your Email</h1>
      <p>A link was sent to <strong>{user.email}</strong>.</p>
      
      <div className={styles.buttonGroup}>
        <button 
          className={styles.verifyButton}
          disabled={checking || resending}
          onClick={onVerifyEmail}
        >
          {checking ? "Verifying..." : "I've verified my email"}
        </button>

        <button 
          className={styles.resendButton}
          disabled={resending || checking}
          onClick={onResendVerification}
        >
          {resending ? "Sending..." : "Resend Verification Email"}
        </button>
      </div>

      {resendStatus && <p className={styles.statusMessage}>{resendStatus}</p>}
    </div>
  );
};

EmailVerificationView.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  onVerifyEmail: PropTypes.func.isRequired,
  onResendVerification: PropTypes.func.isRequired,
  checking: PropTypes.bool.isRequired,
  resending: PropTypes.bool.isRequired,
  resendStatus: PropTypes.string,
};

export default EmailVerificationView;